import React, { useEffect, useState } from "react";
import {
  Table,
  Layout,
  Row,
  Col,
  Button,
  Typography,
  Select,
  ConfigProvider,
} from "antd";
import {
  useNavigate,
  Link,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { downloadFile } from "../../helper/UtilityMethods";
import {
  getTrainignAssessmentUsers,
  downloadQCResults,
} from "../../services/ApiActions/adminAct";
import Loader from "../../components/Layout/Loader";
import { render } from "@testing-library/react";
import FailPassTag from "../../components/Misc/FailPassTag";

const { Content } = Layout;
const { Title } = Typography;

const TrainingAssessmentUserListPage = () => {
  /** 🔹 Navigation Hook */
  const params = useParams();
  const { assessmentId } = params;

  /** 🔹 State Hooks */
  const [users, setUsers] = useState([]);
  const [assessmentName, setAssessmentName] = useState('');
  const [isUserLoading, setIsUserLoading] = useState(true);

  /** 🔹 Event Handlers */
  const handleOnDownloadResultClick = async (assessmentId: string) => {
    try {
      const response: any = await downloadQCResults(assessmentId);
      const downloadInfo = {
        blobData: response,
        contentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        fileNameWithExt: `${assessmentName}-scores.xlsx`,
      };
      downloadFile(downloadInfo);
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
    }
  };

  /** 🔹 Fetch Users on department change */
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setIsUserLoading(true);
        const response: any = await getTrainignAssessmentUsers({
          certification_id: assessmentId,
        });
        setUsers(response.data);
        setAssessmentName(response?.additional_info?.assessment_name);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setIsUserLoading(false);
      }
    };
    fetchUsers();
  }, []);

  /** 🔹 Fetch Department List */

  /** 🔹 Table Column Definitions */
  const columns = [
    {
      title: "Name",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
    },
    {
      title: "Result",
      dataIndex: ["progress_result", "result"], // Directly map to nested property
      key: "result",
      width: 150,
      render: (result: string) => <FailPassTag result={result} />,
    },
    /*{
      title: "Status",
      dataIndex: ["progress_result", "certification_status"], // Directly map to nested property
      key: "certification_status",
      width: 150,
    },*/
    {
      title: "Details",
      dataIndex: "id",
      key: "id",
      width: 150,
      //assessment_id=3&course_id=3&user_id=422
      render: (id: string) => (
        <Link
          to={`/admin-training-assessment-review?user_id=${id}&id=${assessmentId}`}
          style={{ display: "flex", gap: "5px" }}
        >
          <span>Details</span>{" "}
          <ArrowTopRightOnSquareIcon className="custom-icon hero-icon-18" />
        </Link>
      ),
    },
  ];

  /** 🔹 Show Loader when data is loading */
  if (isUserLoading) {
    return <Loader style={{ marginTop: "20%", justifyContent: "center" }} />;
  }

  /** 🔹 Render UI */
  return (
    <Layout style={{ padding: "10px 0" }}>
      <Content>
        <Row gutter={16}>
          <Col span={24}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Title level={3} style={{ margin: "0 0 0 5px", flexGrow: 1 }}>
                Users
              </Title>
              <div>
              <Button
                  type="primary"
                  onClick={() =>
                    assessmentId !== null &&
                    assessmentId !== undefined &&
                    handleOnDownloadResultClick(assessmentId)
                  }
                >
                  <DownloadOutlined /> Download Scores
                  </Button>
                
              </div>
            </div>
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    cellFontSize: 16,
                  },
                },
              }}
            >
              <Table
                className="custom-table users-list"
                bordered={false}
                columns={columns}
                dataSource={users}
              />
            </ConfigProvider>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default TrainingAssessmentUserListPage;
